import { LogoImg } from './styles'
import LogoBlue from 'components/Logo/assets/logo-blue.svg'
import LogoWhite from 'components/Logo/assets/logo-white.svg'

interface IProps {
  color: 'blue' | 'white'
}

const Logo = (props: IProps) =>
  <LogoImg
    src={props.color === 'blue' ? LogoBlue : LogoWhite}
  />

export default Logo
